var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitAdvisoryMphNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_mph_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_mph_x5F_nar"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2B236"
    },
    d: "M10,6h76c2.209,0,4,1.791,4,4v76c0,2.209-1.791,4-4,4H10 c-2.209,0-4-1.791-4-4V10C6,7.791,7.791,6,10,6z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86,10v76H10V10H86 M86,8H10c-1.105,0-2,0.895-2,2v76c0,1.105,0.895,2,2,2h76c1.105,0,2-0.895,2-2V10 C88,8.895,87.104,8,86,8L86,8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.216,82.044L36.6,73.5h1.704l2.196,5.916l2.16-5.916h1.668l0.432,8.544h-1.428l-0.288-5.796l-2.1,5.796H39.96 l-2.148-5.832l-0.24,5.832H36.216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.272,73.5h3.144c0.472,0,0.876,0.048,1.212,0.145c0.336,0.096,0.612,0.25,0.828,0.461 c0.216,0.213,0.374,0.49,0.474,0.834c0.101,0.345,0.15,0.769,0.15,1.272c0,0.536-0.057,0.979-0.168,1.332 c-0.112,0.353-0.278,0.634-0.498,0.847c-0.221,0.211-0.498,0.361-0.834,0.449s-0.728,0.133-1.176,0.133h-1.656v3.071h-1.476V73.5z  M47.748,74.844v2.881h1.5c0.256,0,0.47-0.019,0.642-0.055s0.307-0.107,0.408-0.216s0.172-0.259,0.216-0.45 s0.066-0.439,0.066-0.744c0-0.287-0.022-0.523-0.066-0.708c-0.044-0.184-0.117-0.327-0.222-0.432s-0.242-0.177-0.414-0.216 c-0.172-0.041-0.382-0.061-0.63-0.061H47.748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.279,73.5h1.477v3.6h3.348v-3.6h1.488v8.544h-1.488v-3.685h-3.348v3.685h-1.477V73.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitAdvisoryMphNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_advisory_mph_nar.44071541916faf8ed121f79a68b2b471.svg";
export { ForwardRef as ReactComponent };